
import React from 'react';
import AdminRoute from '@/components/AdminRoute';
import { Card } from '@/components/ui/card';
import AdminHeader from '@/components/admin/AdminHeader';
import { useIsMobile } from '@/hooks/use-mobile';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SubscriptionStatsChart from '@/components/admin/stats/SubscriptionStatsChart';
import UserStatsOverTimeChart from '@/components/admin/stats/UserStatsOverTimeChart';
import NewSubscriptionsTable from '@/components/admin/stats/NewSubscriptionsTable';

const AdminStats: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <AdminRoute>
      <div className="container py-6 px-4 md:py-10 md:px-6">
        <AdminHeader isMobile={isMobile} />
        
        <Tabs defaultValue="trends" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="trends">Subscription Trends</TabsTrigger>
            <TabsTrigger value="distribution">Current Distribution</TabsTrigger>
          </TabsList>
          
          <TabsContent value="trends">
            <Card className="p-4 md:p-6">
              <h2 className="text-xl font-semibold mb-6">New Subscriptions (Last 7 Days)</h2>
              <NewSubscriptionsTable />
              
              <div className="mt-10">
                <h2 className="text-xl font-semibold mb-6">User Subscription Trends</h2>
                <UserStatsOverTimeChart />
              </div>
            </Card>
          </TabsContent>
          
          <TabsContent value="distribution">
            <Card className="p-4 md:p-6">
              <h2 className="text-xl font-semibold mb-6">Current Subscription Distribution</h2>
              <SubscriptionStatsChart />
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </AdminRoute>
  );
};

export default AdminStats;
